export default __webpack_public_path__ + "static/media/Trade_Gothic_LT_Bold.b97b314b.ttf";